import React, {Component} from 'react'
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import ResultItem from "./ResultItem";
import {actions as label} from "../../reducers/label";
import {actions as system} from "../../reducers/system";
import {actions as labelCollection} from "../../reducers/labelCollection";

@connect(
    state => {
        return {
            selectedProject: state.project.selected,
            highlightedLabelCollection: state.labelCollection.highlighted
        }
    },
    dispatch => {
        return {
            setInputText: (input) => dispatch(system.setTextInput(input)),
            updateHighlightedLabel: labelToHighlight => dispatch(label.highlightLabel(labelToHighlight)),
            updateHighlightLabelCollection: (lc) => dispatch(labelCollection.highlightLabelCollection(lc))
        };
    })
export default class Result extends Component {
    static propTypes = {
        labelResults: PropTypes.array,
        collectionResult: PropTypes.array
    };

    render() {
        const {labelResults, collectionResult, selectedProject} = this.props;

        return (
            <div>
                <hr/>
                <table className="table">
                    {Object.keys(labelResults).length > 0 &&
                        <React.Fragment>
                            <thead className="">
                                <tr>
                                    <th>Label</th>
                                </tr>
                            </thead>
                            <tbody>
                                {labelResults.map((label, index) => {
                                    return (<ResultItem key={index} name={label.labelCollectionIdentifier} link={`${selectedProject.name}/${encodeURIComponent(label.labelCollectionIdentifier)}`} displayName={label.name} clickHandler={() => {
                                        this.props.setInputText('')
                                        this.props.updateHighlightedLabel(label)
                                    }}/>)
                                })}
                            </tbody>
                        </React.Fragment>
                    }
                    {Object.keys(collectionResult).length > 0 &&
                        <React.Fragment>
                            <thead className="">
                                <tr>
                                    <th>Collection</th>
                                </tr>
                            </thead>
                            <tbody>
                                {collectionResult.map((collection, index) => {
                                    return(<ResultItem key={index} name={collection.identifier} link={`${selectedProject.name}/${encodeURIComponent(collection.identifier)}`} displayName={collection.displayName} clickHandler={() => {
                                        this.props.setInputText('')
                                        this.props.updateHighlightLabelCollection(collection)
                                    }}/>)
                                })}
                            </tbody>
                        </React.Fragment>
                    }
                </table>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./React/src/components/LabelSearch/Result.js